import type { IconProps } from './types';
import './icons.css';

export default function ChangeLogUpdated({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-change-log-updated ${className || ''}`}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill="#000"
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm3.052 9.46a.725.725 0 0 0 .016-1.028.728.728 0 0 0-1.028-.016l-1.313 1.27V4.598a.728.728 0 0 0-1.454 0v5.09L5.96 8.416A.727.727 0 1 0 4.95 9.461l2.545 2.464a.727.727 0 0 0 1.012 0l2.546-2.464Z"
      />
    </svg>
  );
}
